import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { LoginComponent } from './users/login';
import { RegisterComponent } from './register';
import { ListComponent } from './list/list.component';
import { StatusFfComponent } from './status-ff/status-ff.component';
import { SalesComponent } from './sales';
import { ShopiAuthsComponent } from './shopi-auths/shopi-auths.component';
import { InvoicesComponent } from './navegacion/invoices/invoices.component';
import { TransactionsComponent } from './transactions';
import { CedunosComponent } from './cedunos';
import { CedosComponent } from './cedos';
import { CetresComponent } from './cetres';
import { BackofficeComponent } from './backoffice';
import { AuthGuard } from './_helpers';
import { RestaurarComponent } from './users/restaurar';
import { DefaultComponent } from './users/default.component';
import { NavegacionComponent } from './navegacion/navegacion.component';
import { EntradasComponent, EntradasTab1, EntradasTab2, EntradasTab3 } from './navegacion/entradas/entradas.component';
import { FulfillmentsComponent, FulfillmentsTab1, FulfillmentsTab2, FulfillmentsTab3,FulfillmentsTab4 } from './navegacion/fulfillments/fulfillments.component';
import { InventariosComponent, InventariosTab1, InventariosTab2, InventariosTab3 } from './navegacion/inventarios/inventarios.component';
import { ReportsComponent, ReportsTab1, ReportsTab2, ReportsTab3 } from './navegacion/reports/reports.component';
import { IntegrationsComponent } from './navegacion/integrations/integrations.component';
import { AccountsComponent } from './navegacion/accounts/accounts.component';
import { SupportsComponent } from './navegacion/supports/supports.component';
import { ProductosComponent, ProductosTab1,ProductosTab2 } from './navegacion/productos/productos.component';
import { CanalesComponent } from './navegacion/canales/canales.component'; 
import { DevolucionsComponent, DevolucionsTab1, DevolucionsTab2 } from './navegacion/devolucions/devolucions.component';
import { TicketComponent, TicketsTab1, TicketsTab2, TicketsTab2Sub1, TicketsTab2Sub2, TicketsTab2Sub3 } from './navegacion/tickets/tickets.component';
import { DashboardsComponent } from './navegacion/dashboard/dashboards.component';
import { AvisodeprivacidadComponent } from './navegacion/avisodeprivacidad/avisodeprivacidad.component'; 
import { ConnectAmazonComponent } from "./navegacion/connect-amazon/connect-amazon.component";
import { ConfirmarEntradaComponent } from './confirmar-entrada/confirmar-entrada.component';
import { VerOrdenEntradaComponent } from './navegacion/entradas/ver-orden-entrada/ver-orden-entrada.component';
const routes: Routes = [
	// {path: '', component: HomeComponent, canActivate: [AuthGuard] },
	{
		path: '', 
		component: NavegacionComponent, 
		canActivate: [AuthGuard] ,
		children: [
			{path: 'entradas',component: EntradasComponent},
			{path: 'entradas/ver/:token', component: VerOrdenEntradaComponent},
			{path: '',component: DashboardsComponent},
			{path: 'fulfillments',component: FulfillmentsComponent},
			{path: 'inventarios',component: InventariosComponent},
			{path: 'invoices',component: InvoicesComponent},
			{path: 'reports',component: ReportsComponent},
			{path: 'integrations',component: IntegrationsComponent},
			{path: 'accounts',component: AccountsComponent},
			{path: 'supports',component: SupportsComponent},
			{path: 'productos',component: ProductosComponent},
			{path: 'canales',component: CanalesComponent},
			{path: 'devoluciones',component: DevolucionsComponent},
			{path: 'tickets',component: TicketComponent},
			{path: 'connect-amazon',component: ConnectAmazonComponent}
		]
	},
	{
		path: 'login',
		component: DefaultComponent,
		children: [
		{
			path: 'user',
			component: LoginComponent
		},{
			path: 'restaurar',
			component: RestaurarComponent
		},
		{
			path: '',
			component: LoginComponent
		}]
	},
  {path: 'registro', component: RegisterComponent },
  // {path: 'restaurar', component: RestaurarComponent },
	{path: 'list', component: ListComponent, canActivate: [AuthGuard] },
	{path: 'status-ff', component: StatusFfComponent, canActivate: [AuthGuard] },
	{path: 'sales', component: SalesComponent, canActivate: [AuthGuard] },
	{path: 'shopi-auths', component: ShopiAuthsComponent, canActivate: [AuthGuard] },
	{path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuard] },
	{path: 'transactions', component: TransactionsComponent, canActivate: [AuthGuard] },
	{path: 'cedunos', component: CedunosComponent, canActivate: [AuthGuard] },
	{path: 'cedos', component: CedosComponent, canActivate: [AuthGuard] },
	{path: 'cetres', component: CetresComponent, canActivate: [AuthGuard] },
	{path: 'backoffice', component: BackofficeComponent, canActivate: [AuthGuard] },
	{path: 'avisodeprivacidad', component: AvisodeprivacidadComponent},
	{ path: 'entradas/confirmar/:token', component: ConfirmarEntradaComponent },
	// otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const appRoutingModule = RouterModule.forRoot(routes);
